import './service-category-unavailable.css'
import warning from '../../../../images/warning.svg'
const ServiceCategoryUnavailable = ({ category }) => {
    return (
        <div className="unavailable-container">
            <img src={warning} alt="warning" className="warning-icon"/>
            <div className="inner-container">
                <h2 className="title">Service Unavailable</h2>
                <p className="description">Currently we are unable to provide services related to {category.split('-').map(x => x[0].toUpperCase() + x.substring(1))} Please Try again Later.</p>
            </div>
        </div>
    )
}

export default ServiceCategoryUnavailable